import Image from '../image';
import Link from 'next/link';
import { SmallButton } from '../button';

interface IBgCardProps {
  title: string;
  subTitle: string;
  bgImageUrl: string;
  linkText: string;
  linkHref: string;
  isBlank?: boolean;
}

export const BgCard: React.FC<IBgCardProps> = ({
  bgImageUrl,
  title,
  subTitle,
  linkText,
  linkHref,
  isBlank,
}) => {
  return (
    <div className="relative rounded-lg mobile:rounded-md overflow-hidden">
      <div className="rounded-lg  mobile:rounded-md h-[178px] w-full mobile:h-[162px]">
        <Image
          src={bgImageUrl}
          alt="背景图片"
          className="rounded-lg mobile:rounded-md h-full object-cover mobile:w-full"
          height={178}
          width={502}
        />
      </div>
      <div className="absolute left-0 top-0 w-full h-full">
        <div className="p-[30px] flex flex-col h-full justify-between mobile:p-5">
          <p className="flex flex-col">
            <span className="text-base -leading-[1px] text-primary mobile:text-sm font-500 line-clamp-1 break-all">
              {title}
            </span>
            <span className="text-sm -leading-[1px] text-primary/[.6] my-2 mobile:text-xs mobile:my-[6px] line-clamp-1 break-all">
              {subTitle}
            </span>
          </p>
          <Link
            className="w-fit"
            href={linkHref}
            target={isBlank ? '_blank' : '_self'}
          >
            <SmallButton>{linkText}</SmallButton>
          </Link>
        </div>
      </div>
    </div>
  );
};
